// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Tca-z","narrowOptionButtons":"Uca-z","noOptions":"Vca-z"};